import { render, staticRenderFns } from "./部門.vue?vue&type=template&id=1ec08330&scoped=true&"
import script from "./部門.ts?vue&type=script&lang=ts&"
export * from "./部門.ts?vue&type=script&lang=ts&"
import style0 from "./部門.css?vue&type=style&index=0&id=1ec08330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec08330",
  null
  
)

export default component.exports